import React from 'react'
import { ShopImg } from './ShopImg'
import { ShopInfoAccordian } from './ShopInfoMain/ShopInfoAccordian'
import ShopInfoDec from './ShopInfoMain/ShopInfoDec'
import { ShopInfoRating } from './ShopInfoMain/ShopInfoRating'
import { useLocation } from 'react-router-dom';
import productData from '../../json/product.json'

function ShopInfosection1() {
  const location = useLocation();
  const searchParams1 = new URLSearchParams(location.search);
  const imgid = searchParams1.get("id");

  const data = productData && productData?.newPrd?.filter((x) => x?.id?.toString() === imgid)

  return (
      <div className="flex justify-center p-10 md:px-20 lg:px-28  mt-2">
        <div className=" shop1" style={{ direction: 'row' }}>
          <div className="image-info">
            <ShopImg product={data} />
            <div className=" infomain">
              <div className='hidden md:block'>
                <ShopInfoRating product={data} />
              </div>
              <div className='block md:hidden'>
                <ShopInfoAccordian product={data} />
              </div>
            </div>
          </div>
          <div className='hidden  md:block'>
            <ShopInfoDec product={data} />
          </div>
        </div>
      </div>
  
  );
}

export default ShopInfosection1
